import { useMemo } from 'react';

declare global {
  interface Window {
    MP_DEVICE_SESSION_ID?: string;
  }
}

export function deviceSessionId(): string | null {
  return window.MP_DEVICE_SESSION_ID?.trim() || null;
}

function getMercadoPagoPublicKey(): string | null {
  const meta = document.querySelector('meta[name="mercadopago-public-key"]');
  return meta?.getAttribute('content')?.trim() || null;
}

export function useMercadoPagoPublicKey(): string | null {
  return useMemo(() => getMercadoPagoPublicKey(), []);
}
